import { Component } from '@theme/component';

/**
 * A custom element for review stars placeholder
 *
 */
export class YotpoReviewStarsWrapper extends Component {
  requiredRefs = ['yotpoWrapper']

  /**
   * An mutation observer for monitoring Yotpo Review Widget
   * @type {MutationObserver | null}
   */
  #mutationObserver = null;

  /**
   * @type {ReturnType<typeof setTimeout> | null}
   */
  #timeout = null

  #mutationConfig = { attributes: true }

  connectedCallback() {
    super.connectedCallback()

    const { yotpoWrapper } = this.refs

    this.#timeout = window.setTimeout(() => {
      this.#mutationObserver?.disconnect();
      this.markFallback();
    }, 8000);
    
    this.#mutationObserver = new MutationObserver(this.#mutationCallback.bind(this));
    if (yotpoWrapper && !Array.isArray(yotpoWrapper)) {
      this.#mutationObserver.observe(yotpoWrapper, this.#mutationConfig)
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#mutationObserver?.disconnect();
    if (this.#timeout) {
      clearTimeout(this.#timeout)
    }
  }

  markFallback() {
    this.classList.add('review-wrapper--fallback')
  }

  /**
   * 
   * @param {MutationRecord[]} mutations 
   */
  #mutationCallback(mutations) {
    for (const mutation of mutations) {
      if (mutation.type == 'attributes') {
        if (mutation.attributeName == 'data-yotpo-element-loaded') {
          if (this.#timeout) {
            clearTimeout(this.#timeout)
          }
          this.#mutationObserver?.disconnect()
        }
      }
    }
  }
}

if (!customElements.get('yotpo-review-stars-wrapper')) customElements.define('yotpo-review-stars-wrapper', YotpoReviewStarsWrapper);
